import styles from './Paginator.module.scss';
import { useContext, useEffect, useState } from 'react';
import * as _ from 'lodash';
import IGenericResult from '../../interfaces/IGenericResult';
import { AppContext } from '../../context/AppContext';

interface IPaginatorProps {
  resultChunks: IGenericResult[][];
  currentPage: number;
  setCurrentPage: (pageIndex: number) => void;
}

const Paginator = ({ resultChunks, setCurrentPage, currentPage }: IPaginatorProps) => {
  return (
    <div className={styles.paginatorContainer}>
      <button className={styles.paginatorItem} onClick={() => setCurrentPage(_.clamp(0, 0, resultChunks.length - 1))}>
        {resultChunks.length > 0 ? '1...' : '0'}
      </button>
      <button className={styles.paginatorItem} onClick={() => setCurrentPage(_.clamp(currentPage - 1, 0, resultChunks.length - 1))}>
        {'<'}
      </button>
      {/* TODO:*/}
      {resultChunks.map((chunk, index) => {
        const upperMod = currentPage < 3 ? 3 - currentPage : 0;
        const lowerMod = currentPage > resultChunks.length ? currentPage - resultChunks.length : 0;
        const upper = currentPage + 2 + upperMod;
        const lower = currentPage - 2 + lowerMod;
        if ((index + 1 < currentPage && index + 1 >= lower) || index + 1 === currentPage || (index + 1 > currentPage && index + 1 <= upper)) {
          return (
            <button key={`pagbtn-${index}`} className={`${styles.paginatorItem} ${currentPage === index ? styles.isActive : ''}`} onClick={() => setCurrentPage(index)}>
              {index + 1}
            </button>
          );
        }
      })}
      <button className={styles.paginatorItem} onClick={() => setCurrentPage(_.clamp(currentPage + 1, 0, resultChunks.length - 1))}>
        {'>'}
      </button>
      <button className={styles.paginatorItem} onClick={() => setCurrentPage(_.clamp(resultChunks.length - 1, 0, resultChunks.length - 1))}>
        {'...' + resultChunks.length}
      </button>
    </div>
  );
};

export default Paginator;
